import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';
import ParcelTemplate, { CarrierParcelTemplate } from '~/types/ParcelTemplate';

export type ParcelTemplateState = {
  readonly isLoadingParcelTemplates: boolean;
  readonly isLoadingCarrierParcelTemplates: boolean;
  // TODO: Convert to hashmap with id as key
  readonly parcelTemplates: readonly ParcelTemplate[];
  readonly carrierParcelTemplates: Readonly<{ [key: string]: CarrierParcelTemplate[] }>;
  readonly isDeleting: boolean;
};

const initialState: ParcelTemplateState = {
  isLoadingParcelTemplates: false,
  isLoadingCarrierParcelTemplates: false,
  parcelTemplates: [],
  carrierParcelTemplates: {},
  isDeleting: false,
};

function parcelTemplateReducer(
  state: ParcelTemplateState = initialState,
  action: ActionTypes,
): ParcelTemplateState {
  switch (action.type) {
    case ActionKeys.PARCEL_TEMPLATE_FETCH:
      return {
        ...state,
        isLoadingParcelTemplates: true,
      };
    case ActionKeys.PARCEL_TEMPLATE_FETCH_SUCCESS:
      return {
        ...state,
        isLoadingParcelTemplates: false,
        parcelTemplates: action.payload.parcelTemplates,
      };
    case ActionKeys.PARCEL_TEMPLATE_FETCH_ERROR:
      return {
        ...state,
        isLoadingParcelTemplates: false,
      };
    case ActionKeys.CARRIER_PARCEL_TEMPLATE_FETCH:
      return {
        ...state,
        isLoadingCarrierParcelTemplates: true,
      };
    case ActionKeys.CARRIER_PARCEL_TEMPLATE_FETCH_SUCCESS:
      return {
        ...state,
        isLoadingCarrierParcelTemplates: false,
        carrierParcelTemplates: action.payload.carrierParcelTemplates,
      };
    case ActionKeys.CARRIER_PARCEL_TEMPLATE_FETCH_ERROR:
      return {
        ...state,
        isLoadingCarrierParcelTemplates: false,
      };
    case ActionKeys.DELETE_PACKAGE_TEMPLATE:
      return {
        ...state,
        isDeleting: true,
      };
    case ActionKeys.DELETE_PACKAGE_TEMPLATE_SUCCESS:
      return {
        ...state,
        parcelTemplates: state.parcelTemplates.filter(
          (parcelTemplate) => parcelTemplate.objectId !== action.payload.objectId,
        ),
        isDeleting: false,
      };
    case ActionKeys.DELETE_PACKAGE_TEMPLATE_ERROR:
      return {
        ...state,
        isDeleting: false,
      };
    default:
      return state;
  }
}

export default parcelTemplateReducer;
